import { Injectable, computed, signal } from '@angular/core';

@Injectable()
export class SelectionStore {
  private readonly selectedSignal = signal<Set<string>>(new Set());
  private readonly totalIdsSignal = signal<Set<string>>(new Set()); 
  readonly selectedIdsSignal = computed(() => this.selectedSignal());
  readonly selectedCountSignal = computed(() => this.selectedSignal().size);
  readonly allSelectedSignal = computed(() => this.totalIdsSignal().size > 0 && this.selectedSignal().size === this.totalIdsSignal().size  && [...this.selectedSignal()].every(value => this.totalIdsSignal().has(value)));

  setTotalItems(ids: string[]): void {
    this.totalIdsSignal.set(new Set(ids));
  }
  isSelected(id: string): boolean {
    return this.selectedSignal().has(id);
  }

  toggleRow(id: string): void {
    const newSet = new Set(this.selectedSignal());
    if (newSet.has(id)) {
      newSet.delete(id);
    } else {
      newSet.add(id);
    }
    this.selectedSignal.set(newSet);
  }

  toggleAll(): void {
    let newSet = new Set<string>();
    if (!this.allSelectedSignal()) {
      newSet = this.totalIdsSignal();
    }
    this.selectedSignal.set(newSet);
  }

  clearSelection(): void {
    this.selectedSignal.set(new Set());
  }
}
